import { Plus } from '@phosphor-icons/react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from 'core/components';
import { orderPartsPath } from 'orders/routes/routePaths';
import { QuoteEntityType } from 'quotes/enums';
import { quotePartsPath } from 'quotes/routes/routePaths';
import { IVendorQuote } from 'quotes/types';
import { Color } from 'theme/enums';

import { IVendorQuoteCreateForm } from './types';
import { VendorQuoteUpsert } from './VendorQuoteUpsert';
import { TVendorQuoteUpsertHiddenFields } from './VendorQuoteUpsertForm';

interface IProps {
  entityType: QuoteEntityType;
  defaultValues?: Partial<IVendorQuoteCreateForm>;
  hiddenFields?: Partial<TVendorQuoteUpsertHiddenFields>;
}

const DEFAULT_HIDDEN_FIELDS: TVendorQuoteUpsertHiddenFields = {
  project: false,
  externalProjectName: true,
  externalNumber: true,
  revisionNumber: true,
};

export const AddVendorQuoteButton = ({
  entityType = QuoteEntityType.QUOTE,
  defaultValues = {},
  hiddenFields: customHiddenFields,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();

  const { t } = useTranslation();

  const hiddenFields = useMemo(
    () => ({
      ...DEFAULT_HIDDEN_FIELDS,
      ...customHiddenFields,
    }),
    [customHiddenFields]
  );

  return (
    <>
      <Button
        text={t('buttonLabelAddQuote', { entityType })}
        color={Color.SUCCESS}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
      />

      <VendorQuoteUpsert
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={(quote: IVendorQuote) => {
          if (QuoteEntityType.ORDER === entityType) {
            navigate(orderPartsPath(quote.id));

            return;
          }

          navigate(quotePartsPath(quote.id));
        }}
        defaultValues={defaultValues}
        hiddenFields={hiddenFields}
        entityType={entityType}
      />
    </>
  );
};
